/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';

import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';
import { ScheduleSupervisorSupplierListItemDto } from './scheduling-suppliers.dto';
import { ScheduleSupervisorSupplierListItemMapper } from './scheduling-suppliers.mapper';

@Injectable()
export class SchedulingSuppliersRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAllSuppliers(supervisorId: ID): Observable<ScheduleSupervisorSupplierListItemDto[]> {
    return this.httpGet(
      `/supervisors/${supervisorId}/suppliers`, arrayOf(ScheduleSupervisorSupplierListItemMapper));
  }

  updateSupervisorSuppliers(supervisorId: ID,
                            suppliers: ScheduleSupervisorSupplierListItemDto[]): Observable<ScheduleSupervisorSupplierListItemDto[]> {
    return this.httpPut(
      `/supervisors/${supervisorId}/suppliers`, suppliers, arrayOf(ScheduleSupervisorSupplierListItemMapper));
  }
}
